module.exports = __webpack_public_path__ + "static/media/complexPic10.70e47028.png";